module.exports = __webpack_public_path__ + "static/media/rover.62122fcf.jpeg";